import type { Message, ProcessItem, ProcessItemStatus, RunTrace } from "../../api/types.js";

export function messageRunTrace(message: Message): RunTrace | null {
  const trace = message.meta?.runTrace;
  return trace?.version === 1 && Array.isArray(trace.items) ? trace as RunTrace : null;
}

export function processItems(message: Message): Array<ProcessItem | any> {
  const trace = messageRunTrace(message);
  if (trace) return trace.items;
  if (message.meta?.processTimeline?.length) return message.meta.processTimeline;
  if (message.meta?.activityLog?.length) {
    return message.meta.activityLog.map((event: any) => ({
      ...event,
      kind: event.kind === "thought" ? "activity" : event.kind
    }));
  }
  if (message.meta?.processParts?.length) {
    return message.meta.processParts
      .filter((part: any) => part?.type === "process")
      .flatMap((part: any) => part.items || []);
  }
  return [];
}

export function processElapsed(message: Message, items: any[]) {
  const trace = messageRunTrace(message);
  if (trace) return trace.elapsedMs || 0;
  return message.meta?.processElapsedMs || items.reduce((max, item) => Math.max(max, item.elapsedMs || 0), 0);
}

export function processStatus(message: Message): ProcessItemStatus {
  const trace = messageRunTrace(message);
  if (trace) return trace.status;
  const status = message.meta?.processStatus;
  return status === "running" || status === "waiting" || status === "cancelled" || status === "failed" ? status : "completed";
}
